<script setup>
import AuthLayout from '@/layouts/auth.vue';

defineProps({
    title: { type: String },
    description: { type: String },
});
</script>

<template>
    <AuthLayout>
        <slot />
    </AuthLayout>
</template>
